import React, {Component} from 'react';
import scrollToComponent from 'react-scroll-to-component';
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import JunkSizeMailService from '../../services/JunkSizeMailService';


class BagSize extends Component {
    constructor(props) {
        super(props);

        this.localState = this.props.localState;

        this.JunkSizeMailService = new JunkSizeMailService();

        this.state = {
            type: this.localState.type || '',
            extras: this.localState.extras,
            selected_extras: this.localState.selected_extras,
            modal: false,
            photoModal: false,
            fileNames: [],
            filesForUpload: [],
            first_name: '',
            last_name: '',
            email: '',
            filesError: false,
            filesErrorMessage: '',
            mailSuccess: false,
            mailSuccessMessage: '',
            mailError: false,
            mailErrorMessage: '',
            errorResponse: null
        };

        this.handleSelectType = this.handleSelectType.bind(this);
        this.handleSelectExtraQty = this.handleSelectExtraQty.bind(this);
        this.submitStep = this.submitStep.bind(this);
        this.toggle = this.toggle.bind(this);
        // this.togglePhotoModal = this.togglePhotoModal.bind(this);
        // this.handleInputFileClick = this.handleInputFileClick.bind(this);
        // this.handleSelectedFileNames = this.handleSelectedFileNames.bind(this);
        // this.submitFormData = this.submitFormData.bind(this);
        // this.handleFilesUpload = this.handleFilesUpload.bind(this);

        // window.ga('send', 'event', 'wizard', 'wizard', 'Extras select')
        ga('set', 'page', '/wizard/man-and-van/step-2/extras-select');
        ga('send', 'pageview')
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    handleSelectType(type) {
        this.setState({
            type: type
        }, () => {
            scrollToComponent(this.ExtrasQty, {offset: 0, align: 'middle', duration: 500, ease: 'inExpo'});
            this.localState.type = type;
            this.props.setValidity(true);
        });
    }

    handleSelectExtraQty(event, extra) {
        let extras = [...this.state.extras];
        let selected_extras = [...this.state.selected_extras];

        let updateable = extras.find((item) => item.id === extra.id);

        let selected = selected_extras.find((item) => item.id === extra.id);

        if (!selected) {
            selected_extras.push({
                ...updateable,
                total_price: event.target.value * updateable.price_per_item,
                qty: event.target.value
            });
        }

        if (selected) {
            let index = selected_extras.indexOf(selected);
            selected_extras.splice(index, 1);

            if (event.target.value != '0') {
                selected_extras.push({
                    ...selected,
                    total_price: event.target.value * selected.price_per_item,
                    qty: event.target.value
                });
            }
        }

        this.setState({
            extras: extras,
            selected_extras: selected_extras
        }, () => {
            this.localState.extras = this.state.extras;
            this.localState.selected_extras = this.state.selected_extras;
            this.props.globalStateChange(this.localState);
            this.props.updatePrice();
        });
    }

    displayTotal(extra) {
        let selected_extras = [...this.state.selected_extras];
        let updateable = selected_extras.find((item) => item.id === extra.id);

        if (updateable) {
            return updateable.total_price;
        } else {
            return '0';
        }
    }

    checkDefaultValue(extra) {
        let selected_extras = [...this.state.selected_extras];
        let updateable = selected_extras.find((item) => item.id === extra.id);

        if (updateable) {
            return updateable.qty;
        } else {
            return '';
        }
    }

    submitStep() {
        this.localState.selected_extras = this.state.selected_extras;
        this.props.globalStateChange(this.localState);
        this.props.nextStep();
    }

    render() {
        return (
            <div className='container pb-5'>
                <div className="row justify-content-center pb-3">
                    <h2 className="wizard-heading pt-sm-0 pt-5">Any extras?</h2>
                </div>
                <section className='ExtrasQty' ref={(section) => {
                    this.ExtrasQty = section;
                }}>
                    <div className="row justify-content-center pb-3">
                        <div className="col-md-10">
                            <div className="alert alert-dark">
                                <p style={{marginBottom: '0'}}> Please note we
                                    cannot take <span className='prohibited-items' onClick={this.toggle}><u>prohibited items</u></span>.
                                </p>
                            </div>
                            {this.props.noAddExtras &&
                            <div className="alert alert-dark">
                                <p style={{marginBottom: '0'}}>
                                    Please note that the following items can be collected once your bag is ready for collection, but they incur extra charges.
                                </p>
                            </div>
                            }
                        </div>
                    </div>
                    {!this.props.noAddExtras && this.localState.extras.map((extra, index) => {
                        return (
                            <div className="row justify-content-center my-1" key={extra.id}>
                                <div className="col-md-10">
                                    <div className="card">
                                        <div className="card-body card-wizard">
                                            <div className='row'>
                                                <div className='col-md-2 col-6 order-2 order-md-1'>
                                                    <select name={extra.name} defaultValue={this.checkDefaultValue(extra)}
                                                            className='form-control'
                                                            onChange={(event) => this.handleSelectExtraQty(event, extra)}>
                                                        {Array(extra.max_quantity + 1).fill().map((index, number) => {
                                                            return (
                                                                <option key={number}
                                                                    // value={number*extra.price_per_item}
                                                                        value={number}
                                                                >{number}</option>
                                                            )
                                                        })};
                                                    </select>
                                                </div>
                                                <div
                                                    className='col-md-8 d-flex align-items-center order-1 order-md-2 mb-2'>
                                                    <p style={{marginBottom: '0', color: '#FDB913'}}>{extra.name}</p>
                                                </div>
                                                <div className='col-md-2 col-6 order-3 order-md-3'>
                                                    <div style={{
                                                        border: '1px solid rgba(0,0,0,.125)',
                                                        borderRadius: '4px',
                                                        padding: '.375rem .75rem',
                                                        backgroundColor: '#fff'
                                                    }}>
                                                        &#163;<span>
                                                        {this.displayTotal(extra)}
                                                    </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                    {this.props.noAddExtras && this.localState.extras.map((extra, index) => {
                        return (
                            <div className="row justify-content-center my-1" key={extra.id}>
                                <div className="col-md-10">
                                    <div className="card">
                                        <div className="card-body card-wizard">
                                            <div className='row'>
                                                <div
                                                    className='col-md-9 d-flex align-items-center order-1 order-md-2 mb-2'>
                                                    <p style={{marginBottom: '0', color: '#FDB913'}}>{extra.name}</p>
                                                </div>
                                                <div className='col-md-3 col-6 order-3 order-md-3'>
                                                    <div style={{
                                                        // border: '1px solid rgba(0,0,0,.125)',
                                                        borderRadius: '4px',
                                                        padding: '.375rem .75rem',
                                                        color: '#fff'
                                                    }}>
                                                        &#163;<span>
                                                        {extra.price_per_item} (inc. VAT)
                                                    </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}

                    <div className="row justify-content-center mt-5">
                        <button className="btn btn-round btn-cw btn-back py-3 mx-2" onClick={this.props.prevStep}>Back
                        </button>
                        <button className="btn btn-round btn-cw btn-next btn-yellow py-3 mx-2"
                                onClick={this.submitStep}>Next
                        </button>
                    </div>
                </section>


                <Modal isOpen={this.state.modal} toggle={this.toggle}>
                    <ModalHeader toggle={this.toggle}>Prohibited items</ModalHeader>
                    <ModalBody>
                        <div className="container text-left">
                            <p>Unfortunately we are able to collect any of the following items, for health & safety and regulatory reasons:</p>
                            <ul>
                                <li>American style fridge, freezer or commercial units</li>
                                <li>Asbestos</li>
                                <li>Batteries</li>
                                <li>Biological or Medical waste</li>
                                <li>Box style CRT television(s) or monitor(s).</li>
                                <li>Chemicals (including toxic substances, noxious chemicals & solvents)</li>
                                <li>Gas bottles</li>
                                <li>Fire extinguisher</li>
                                <li>Fuels (Petrol, Diesel & Oil)</li>
                                <li>Pianos</li>
                                <li>Raw meat or raw fish (unless packaged)</li>
                                <li>Rubble or soil (due to weight)</li>
                                <li>Unbagged domestic refuse</li>
                            </ul>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <button className='btn btn-round py-3 btn-cw btn-yellow' onClick={this.toggle}>Continue</button>
                    </ModalFooter>
                </Modal>

            </div>
        );
    }
}

export default BagSize;

